export const environment = {
  production: true,
  STORAGE_PREFIX: '@eds-admin-portal',
  LOGIN_PAGE_URL: 'https://admin.everydayspeech.com/login?logout=1',
  PLATFORM_ACCESS_BASE_URL: 'https://platform-access-service.everydayspeech.com',
  ddApplicationId: '599e1a9f-5847-45bf-b675-28dd7ea2f965',
  ddClientToken: 'pubfad5e4aa1a95f75189c13228e7603c80',
  ddService: 'admin-portal-production',
  ddEnv: 'production',
  ddRumSampleRate: 100,
  userpilotToken: 'NX-2b269cee',
  posthogPublicApiKey: 'phc_cmliTNPQJIxhoGO48Kf03CMg6u39T22fPtimIMoCw8x',
  posthogApiHost: 'https://d1j1m37vtn36nh.cloudfront.net',
  currentOrganizationId: '11111111-1111-1111-1111-111111111111',
  adminPortalV1Url: 'https://admin.everydayspeech.com',
  // Cognito Hosted UI (admin-portal SSO).
  COGNITO_HOSTED_UI_DOMAIN: 'https://login.everydayspeech.com',
  COGNITO_ADMIN_CLIENT_ID: '5cbi2bps1cfm47likduue8338q',
  COGNITO_REDIRECT_URI: 'https://admin-v2.everydayspeech.com/auth/callback',
  COGNITO_LOGOUT_URI: 'https://admin-v2.everydayspeech.com/login',
  COGNITO_SCOPES: 'openid email profile',
}
